import { IRangBuoc } from "../../../model/respone/category/IRangBuoc";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eRangBuocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IRangBuoc[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IRangBuoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IRangBuoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};
export const eRangBuocActionIds = generateActionTypeIds(
  eRangBuocActionsObj,
  "RANG_BUOC"
);
export type IRangBuocActionTypes = IGenericActionType<
  typeof eRangBuocActionsObj,
  "RANG_BUOC"
>;
